import { render, staticRenderFns } from "./transfer-money.vue?vue&type=template&id=1b8bd0ba&scoped=true"
import script from "./transfer-money.vue?vue&type=script&lang=js"
export * from "./transfer-money.vue?vue&type=script&lang=js"
import style0 from "./transfer-money.vue?vue&type=style&index=0&id=1b8bd0ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8bd0ba",
  null
  
)

export default component.exports